import { tr } from "../i18n/idioma";
import { ENFOQUE } from "./videoComun";

/* Pie del vídeo de apertura de la portada: una línea, como el de las imágenes.
   Enfoque y autor a la vista; la nota de Yamacoa y el aviso largo quedan en la noticia.
   «Lo sirve YouTube al pulsar» es el aviso de privacidad mínimo antes de cargarlo. */
export default function PieVideoPortada({ enfoque, autor, cargado }) {
  const partes = [tr("Vídeo", "Video"), ENFOQUE()[enfoque], autor,
    cargado ? "YouTube" : tr("lo sirve YouTube al pulsar", "served by YouTube on play")];
  return <figcaption className="yyt-pie-portada">{partes.filter(Boolean).join(" · ")}</figcaption>;
}
